import State from 'store/State';
import {
    initialSymbolTilesSymbolState,
    SymbolTilesSymbolState,
} from 'widgets/symbolTile/store/data/SymbolTilesStreamState';
import { StreamMessage } from 'utils/messages/StreamMessage';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';

export const selectSymbolTilesStreamState = (state: State) =>
    selectStreamedDataState(state).symbolTiles;

export const selectSymbolTileState: (
    state: State,
    symbol?: string
) => SymbolTilesSymbolState = (state, symbol) =>
    symbol
        ? selectSymbolTilesStreamState(state).data[symbol] ?? {
              ...initialSymbolTilesSymbolState,
          }
        : { ...initialSymbolTilesSymbolState };

export const selectSymbolMessages: (
    state: State,
    symbol?: string
) => StreamMessage[] = (state, symbol) => {
    const messages = selectSymbolTilesStreamState(state).messages;
    const symbolMessages = selectSymbolTileState(state, symbol).messages;
    return [...messages, ...symbolMessages];
};
